<div class="grid grid-cols-12 gap-4">
  <div class="col-span-12 d-flex items-center justify-center">
    <div class="card w-full relative !p-2">
      <div class="flex items-center justify-center relative ml-2">
        <button
          pButton
          pRipple
          icon="pi pi-arrow-left"
          class="p-button-text text-color p-button-rounded mr-2 p-button-secondary border-surface-200 dark:border-surface-600 absolute left-0"
          (click)="backToFactoryPage()"
        ></button>

        <h1 class="text-xl font-bold text-center w-full">
          <span id="alarm-id">
            {{ rule?.context }}
          </span>
        </h1>
        <div class="absolute right-0 flex items-center gap-4">
          <div class="flex items-center gap-2">
            <span class="text-sm font-medium text-color">Activer le suivi</span>
            <p-toggleSwitch
              [ngModel]="rule?.isTracked ?? false"
              [ngModelOptions]="{ standalone: true }"
              name="isTracked"
              (ngModelChange)="onTrackedToggle($event)"
            ></p-toggleSwitch>
          </div>
          <ng-container
            *ngIf="rule?.latestAlarm?.status === AlarmStatus.Enabled"
          >
            <p-button
              *ind4HasRole="'SED_PLUS_ADMIN'"
              type="button"
              class="send-btn self-start my-2"
              severity="danger"
              (click)="onCloseAlert()"
              ><h3 class="text-base font-semibold text-color">
                Fermer l'alerte
              </h3></p-button
            >
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="col-span-12 md:col-span-4">
    <div class="flex flex-col h-full">
      <div class="card md:max-h-[90vh] md:overflow-y-auto min-h-[40vh]">
        <p-tabs styleClass="custom-alarm-tabs" [(value)]="detailsTabValue">
          <p-tablist>
            <p-tab value="description">Description</p-tab>
            <p-tab value="journal">Journal</p-tab>
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="description">
              <app-description
                [description]="rule?.description"
                [behaviorSummary]="rule?.behaviorSummary"
              ></app-description>
            </p-tabpanel>
            <p-tabpanel value="journal">
              <app-historical [ruleUid]="ruleUid"></app-historical>
            </p-tabpanel>
          </p-tabpanels>
        </p-tabs>
      </div>

      <div class="card flex-1">
        <div class="flex flex-row justify-between">
          <h2 class="text-xl font-semibold text-color mb-5">Informations</h2>
          <div class="flex gap-2">
            <p-button
              *ind4HasRole="'SED_PLUS_REGULAR_USER'"
              size="small"
              styleClass="font-semibold"
              (onClick)="onclickModifyRule()"
              [outlined]="true"
              [disabled]="!rule"
            >
              Modifier
              <i-lucide
                name="file-pen"
                class="text-white-400"
                [size]="16"
              ></i-lucide>
            </p-button>

            <p-button
              *ind4HasRole="'SED_PLUS_ADMIN'"
              size="small"
              styleClass="font-semibold"
              (onClick)="onDeleteRule()"
              [outlined]="true"
              [disabled]="!rule"
              severity="danger"
            >
              Supprimer
              <i-lucide
                name="trash-2"
                class="text-white-400"
                [size]="16"
              ></i-lucide>
            </p-button>
          </div>
        </div>
        <app-data-state [loading]="loading$ | async" [error]="error$ | async">
          <p-tabs styleClass="custom-alarm-tabs" [(value)]="infoTabValue">
            <p-tablist>
              <p-tab value="general">Général</p-tab>
              <p-tab value="gains">Gains</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel value="general">
                <div class="flex flex-col gap-4">
                  <div
                    class="flex justify-between border-b border-gray-300 pb-2"
                  >
                    <span class="text-muted-color">Santé</span>
                    <lucide-icon
                      [name]="
                        isRuleStale(rule)
                          ? 'clock'
                          : rule?.lastErrorType
                            ? 'circle-x'
                            : 'circle-check'
                      "
                      [style.color]="
                        isRuleStale(rule)
                          ? 'orange'
                          : rule?.lastErrorType
                            ? 'red'
                            : 'green'
                      "
                      size="20"
                    ></lucide-icon>
                  </div>
                  <div
                    class="flex justify-between border-b border-gray-300 pb-2"
                  >
                    <span class="text-muted-color">Active</span>
                    <lucide-icon
                      [name]="rule?.isActive ? 'circle-check' : 'circle-x'"
                      [style.color]="rule?.isActive ? 'green' : 'red'"
                      size="20"
                    ></lucide-icon>
                  </div>
                  <div
                    class="flex justify-between border-b border-gray-300 pb-2"
                  >
                    <span class="text-muted-color">Alarm</span>
                    <div class="flex items-center justify-center">
                      <lucide-icon
                        [name]="
                          rule?.latestAlarm?.status ? 'bell-ring' : 'bell'
                        "
                        [style.color]="
                          rule?.latestAlarm?.status ? 'red' : 'gray'
                        "
                        size="20"
                      ></lucide-icon>
                    </div>
                  </div>
                  <div
                    class="flex justify-between border-b border-gray-300 pb-2"
                  >
                    <span class="text-muted-color">Criticité</span>
                    <span
                      class="px-4 py-1 rounded-full text-s"
                      [ngClass]="{
                        'text-red-600 bg-red-100':
                          rule?.criticality === CriticalityLevel.Critical,
                        'text-orange-600 bg-orange-100':
                          rule?.criticality === CriticalityLevel.High,
                        'text-yellow-600 bg-yellow-100':
                          rule?.criticality === CriticalityLevel.Medium,
                        'text-blue-600 bg-blue-100':
                          rule?.criticality === CriticalityLevel.Low,
                      }"
                    >
                      {{ getCriticalityLabel(rule?.criticality) }}
                    </span>
                  </div>
                  <div
                    class="flex justify-between border-b border-gray-300 pb-2"
                  >
                    <span class="text-muted-color shrink-0">Maturité</span>
                    <span
                      id="detail-datetime"
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      <span
                        class="px-4 py-1 rounded-full text-s"
                        [ngClass]="{
                          'text-blue-600 bg-blue-100': rule?.stage === 0,
                          'text-yellow-600 bg-yellow-100': rule?.stage === 1,
                          'text-green-600 bg-green-100': rule?.stage === 2,
                        }"
                      >
                        {{ getStageLabel(rule?.stage) }}
                      </span>
                    </span>
                  </div>
                  <div
                    *ngIf="rule?.workCenterLabels?.length"
                    class="flex flex-nowrap justify-between border-b border-gray-300 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">Étiquettes</span>
                    <div class="flex flex-wrap gap-1 justify-end">
                      <p-tag
                        *ngFor="let label of rule!.workCenterLabels"
                        [value]="label.label"
                        severity="info"
                      ></p-tag>
                    </div>
                  </div>
                  <div
                    class="flex flex-nowrap justify-between border-b border-gray-300 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Date de la dernière évaluation
                    </span>
                    <span
                      id="detail-datetime"
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{
                        rule?.lastEvaluationDateTime
                          ? (rule!.lastEvaluationDateTime
                            | date: "dd/MM/yyyy / HH:mm:ss")
                          : "N/A"
                      }}
                    </span>
                  </div>
                  <div
                    class="flex justify-between border-b border-surface-200 dark:border-surface-600 pb-2"
                  >
                    <span class="text-muted-color">Usine</span>
                    <span class="font-semibold text-color" id="detail-usine">{{
                      rule?.functionalLocation?.sapPlantDescription ||
                        rule?.functionalLocation?.sapPlantId ||
                        "N/A"
                    }}</span>
                  </div>
                  <div
                    class="flex justify-between border-b border-surface-200 pb-2"
                  >
                    <span class="text-muted-color"
                      >Groupe de Planification</span
                    >
                    <span class="font-semibold text-color">{{
                      rule?.functionalLocation?.sapPlannerGroupDescription ||
                        rule?.functionalLocation?.sapPlannerGroupId ||
                        "N/A"
                    }}</span>
                  </div>
                  <div
                    class="flex justify-between border-b border-surface-200 pb-2"
                  >
                    <span class="font text-muted-color">Poste de travail</span>
                    <span class="font-semibold text-color">{{
                      rule?.functionalLocation?.sapWorkCenterDescription ||
                        rule?.functionalLocation?.sapWorkCenterId ||
                        "N/A"
                    }}</span>
                  </div>
                  <div
                    class="flex flex-nowrap justify-between border-b border-surface-200 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Poste Technique
                    </span>
                    <span
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{
                        rule?.functionalLocation?.sapDescription
                          ? rule?.functionalLocation?.sapDescription +
                            " - " +
                            rule?.functionalLocation?.sapId
                          : rule?.functionalLocation?.sapId || "N/A"
                      }}
                    </span>
                  </div>
                  <div
                    class="flex flex-nowrap justify-between border-b border-surface-200 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Nb d'évaluations pour levée d'alerte
                    </span>
                    <span
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{
                        rule?.minEvaluationsToTriggerAlarm != null &&
                        rule?.evaluationsToConsiderForAlarm != null
                          ? rule?.minEvaluationsToTriggerAlarm +
                            "/" +
                            rule?.evaluationsToConsiderForAlarm
                          : "N/A"
                      }}
                    </span>
                  </div>
                  <div class="border-b border-surface-200 pb-2 gap-6">
                    <app-code-display
                      [label]="'Condition d\'activation'"
                      [pythonCode]="rule?.activationConditionPythonExpression"
                    ></app-code-display>
                  </div>

                  <div class="border-b border-surface-200 pb-2 gap-6">
                    <app-code-display
                      [label]="'Équation du modèle'"
                      [pythonCode]="rule?.pythonRule"
                    ></app-code-display>
                  </div>
                  <div
                    class="flex flex-nowrap justify-between border-b border-surface-200 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Semaines avant défaillance
                    </span>
                    <span
                      id="detail-datetime"
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{
                        rule?.weeksBeforeFailure &&
                        rule?.weeksBeforeFailure != null
                          ? rule?.weeksBeforeFailure + " Semaine(s)"
                          : "N/A"
                      }}
                    </span>
                  </div>

                  <div
                    class="flex flex-nowrap justify-between border-b border-surface-200 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Période d'évaluation
                    </span>
                    <span
                      id="detail-datetime"
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{ rule?.periodInMinutes }} Min
                    </span>
                  </div>

                  <div
                    class="flex flex-nowrap justify-between border-b border-surface-200 pb-2 gap-6"
                  >
                    <span class="text-muted-color shrink-0">
                      Interpolation (en minutes) des points PI
                    </span>
                    <span
                      id="detail-datetime"
                      class="font-semibold text-color grow shrink min-w-0 text-right"
                      style="overflow-wrap: break-word"
                    >
                      {{
                        rule?.piPointInterpolationIntervalInMinutes != null
                          ? rule?.piPointInterpolationIntervalInMinutes + " Min"
                          : "N/A"
                      }}
                    </span>
                  </div>
                </div>
              </p-tabpanel>
              <p-tabpanel value="gains">
                <div class="flex flex-col gap-4">
                  <div
                    *ngIf="gainInstancesLoading"
                    class="flex justify-center py-4"
                  >
                    <p-progressSpinner
                      [style]="{ width: '32px', height: '32px' }"
                    ></p-progressSpinner>
                  </div>

                  <div
                    *ngIf="gainInstancesError"
                    class="text-center text-red-500 py-4"
                  >
                    Impossible de charger les formules de gain.
                  </div>

                  <div
                    *ngIf="
                      !gainInstancesLoading &&
                      !gainInstancesError &&
                      !gainInstances?.instances?.length
                    "
                    class="text-center text-muted-color py-4"
                  >
                    Aucune formule de gain définie pour cette règle
                  </div>

                  <div
                    *ngFor="let instance of gainInstances?.instances"
                    class="flex flex-col gap-2 border-b border-gray-300 pb-3"
                  >
                    <div class="flex flex-col min-w-0">
                      <span class="font-semibold text-color">{{
                        instance.templateName
                      }}</span>
                      <span
                        *ngIf="instance.templateTypePath"
                        class="text-xs text-muted-color"
                        >{{ instance.templateTypePath }}</span
                      >
                    </div>
                    <div class="flex flex-wrap gap-x-4 gap-y-1 text-sm">
                      <span
                        *ngFor="let parameter of instance.parameters"
                        class="text-muted-color"
                      >
                        {{ parameter.parameterName }}
                      </span>
                    </div>
                    <small
                      *ngIf="instance.evaluationError"
                      class="text-red-500"
                      >{{ instance.evaluationError }}</small
                    >
                  </div>

                  <div
                    *ngIf="gainInstances?.instances?.length"
                    class="flex justify-between pt-1"
                  >
                    <span class="text-muted-color">Total</span>
                    <span class="font-semibold text-color">
                      {{
                        gainInstances?.totalAmount != null
                          ? (gainInstances?.totalAmount | number: "1.2-2")
                          : "N/A"
                      }}
                    </span>
                  </div>
                </div>
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        </app-data-state>
      </div>

      <div class="card" *ngIf="rule?.latestAlarm?.status">
        <app-evaluation-form
          [ind4RoleDisabled]="'SED_PLUS_SUPER_USER'"
          [selectedAlarm]="rule?.latestAlarm"
          [evaluation]="rule?.latestAlarm?.evaluation"
        ></app-evaluation-form>
      </div>
    </div>
  </div>

  <!-- Right Column -->
  <div class="col-span-12 md:col-span-8 flex flex-col">
    <!-- First card - takes full width -->

    <app-error-message
      *ngIf="rule?.lastErrorMessage && rule?.lastErrorMessage?.length"
      [lastErrorMessage]="rule?.lastErrorMessage"
      [lastErrorType]="rule?.lastErrorType"
    ></app-error-message>
    <div
      *ngIf="
        isRuleStale(rule) &&
        !(rule?.lastErrorMessage && rule?.lastErrorMessage?.length)
      "
      class="mb-3"
    >
      <div
        class="bg-white border border-orange-200 rounded-md p-5 flex items-start gap-3"
      >
        <lucide-icon class="text-orange-500" name="clock"></lucide-icon>
        <div>
          <div class="text-orange-500 font-semibold text-lg mb-1.5">
            Règle en retard
          </div>
          <p class="text-base m-0">
            La règle n'a pas été évaluée depuis plus de 2 fois sa période
            d'évaluation
          </p>
        </div>
      </div>
    </div>
    <div class="card mb-4">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-xl font-semibold">Tendance de Déviation du Modèle</h2>
        <div class="flex items-center gap-2">
          <button
            *ngFor="let period of timeFrames"
            (click)="loadData(period)"
            [ngClass]="{
              'p-button p-button-sm p-button-outlined p-button-secondary shadow-md': true,
              'active-button text-color border-surface-300 inset-shadow-2xs':
                selectedPeriod === period,
            }"
          >
            {{
              period === "7days"
                ? "7 jours"
                : period === "30days"
                  ? "1 mois"
                  : period === "90days"
                    ? "3 mois"
                    : period === "180days"
                      ? "6 mois"
                      : period
            }}
          </button>
        </div>
      </div>

      <app-data-state [loading]="loading$ | async" [error]="error$ | async">
        <div>
          <app-interactive-time-chart
            [datasets]="ruleEvaluationsDataset"
            [height]="400"
            [timePeriod]="chartTimePeriod"
            (onZoom)="onChartZoom($event)"
            (onReset)="onChartReset()"
            [selectedPeriod]="selectedPeriod"
            [chartOptions]="ruleEvaluationChartOptions"
            [additionalPlugins]="ruleEvaluationChartAdditionalPlugins"
          >
          </app-interactive-time-chart>
        </div>

        <div class="flex border-2 border-gray-200 rounded-lg overflow-hidden">
          <div class="flex-1 p-2 text-center relative">
            <div
              class="text-xs font-semibold text-gray-500 dark:text-gray-200 uppercase tracking-wider mb-2"
            >
              Évaluations {{ alertThresholdLabel }} au seuil d'alerte (derniers
              7 jrs.)
            </div>

            <div
              [ngClass]="[
                'text-3xl',
                'font-bold',
                isAlertThresholdRatioUnevaluated
                  ? 'text-gray-400'
                  : getColorClass(alertThresholdRatio),
              ]"
              [pTooltip]="
                isAlertThresholdRatioUnevaluated
                  ? 'Pas encore évalué'
                  : undefined
              "
              tooltipPosition="top"
            >
              {{
                isAlertThresholdRatioUnevaluated
                  ? "N/A"
                  : alertThresholdRatio != null
                    ? (alertThresholdRatio | percent: "1.0-2")
                    : "N/A"
              }}
            </div>
            <div class="absolute right-0 top-1/4 h-1/2 w-px bg-gray-200"></div>
          </div>
          <div class="flex-1 p-2 text-center">
            <div
              class="text-xs font-semibold text-gray-500 dark:text-gray-200 uppercase tracking-wider mb-2"
            >
              Évaluations {{ toleranceThresholdLabel }} au seuil de tolérance
              (derniers 7 jrs.)
            </div>

            <div
              [ngClass]="[
                'text-3xl',
                'font-bold',
                isToleranceThresholdRatioUnevaluated
                  ? 'text-gray-400'
                  : getColorClass(toleranceThresholdRatio),
              ]"
              [pTooltip]="
                isToleranceThresholdRatioUnevaluated
                  ? 'Pas encore évalué'
                  : undefined
              "
              tooltipPosition="top"
            >
              {{
                isToleranceThresholdRatioUnevaluated
                  ? "N/A"
                  : toleranceThresholdRatio != null
                    ? (toleranceThresholdRatio | percent: "1.0-2")
                    : "N/A"
              }}
            </div>
          </div>
        </div>
      </app-data-state>
    </div>

    <div class="card mb-4 pb-12 min-h-[40vh]">
      <h2 class="text-xl font-semibold mb-8">Paramètres Mesurés</h2>
      <ng-template #loadingTpl>
        <div class="flex justify-center items-center min-h-[40vh]">
          <p-progress-spinner ariaLabel="loading" />
        </div>
      </ng-template>
      <div *ngIf="interactivePiChartDatasets; else loadingTpl">
        <app-data-state [loading]="loading$ | async" [error]="error$ | async">
          <div>
            <app-interactive-time-chart
              [datasets]="interactivePiChartDatasets"
              [height]="400"
              [timePeriod]="chartTimePeriod"
              (onZoom)="onChartZoom($event)"
              (onReset)="onChartReset()"
              [chartOptions]="piPointsChartOptions"
              [selectedPeriod]="selectedPeriod"
            >
            </app-interactive-time-chart>
          </div>

          <div class="flex justify-end mt-2"></div>
        </app-data-state>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-4 flex-1">
      <div class="col-span-12 md:col-span-6">
        <app-potential-cause
          class="block h-full"
          [ruleUid]="ruleUid"
        ></app-potential-cause>
      </div>
      <div class="col-span-12 md:col-span-6">
        <app-potential-consequence
          class="block h-full"
          [ruleUid]="ruleUid"
        ></app-potential-consequence>
      </div>
      <div class="col-span-12">
        <app-corrective-actions
          class="block h-full"
          [ruleUid]="ruleUid"
        ></app-corrective-actions>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog #deleteCd [key]="GLOBAL_CONFIRMATION_DELETE"></p-confirmDialog>
<p-confirmDialog #cd [key]="RULE_CONFIRMATION_DELETE">
  <ng-template pTemplate="message" let-message>
    <div class="flex items-center gap-2">
      <i [ngClass]="message.icon" class="!text-3xl"></i>
      <span>{{ message.message }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button
      label="Oui"
      [loading]="isDeleting"
      [disabled]="isDeleting"
      (onClick)="handleAccept()"
    >
    </p-button>

    <p-button
      label="Non"
      severity="secondary"
      [outlined]="true"
      [disabled]="isDeleting"
      (onClick)="cd.onReject()"
    >
    </p-button>
  </ng-template>
</p-confirmDialog>
